import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';

@Component({
  selector: 'time-horizon',
  template: require('./time-horizon.component.html')
})
export class TimeHorizonComponent extends BaseRoute {

  constructor(injector: Injector) {
    super(injector);
  }

  updateOptionValue(event) { }

  btnClick(e) {
    if (e.action === 'next' && this.flowManager.isRetirement) {
      this.router.navigate(['retirement'], { queryParamsHandling: 'preserve' });
      return;
    }
    this.handleClick(e.action);
  }
}
